// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RoleList_role-list__sZ3lw {
  width: 97%;
}
.RoleList_role-list__sZ3lw .RoleList_search-bar__1T-my {
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/SuperAdmin/Pages/RoleList/RoleList.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;AACF;AAAE;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;AAEJ","sourcesContent":[".role-list {\n  width: 97%;\n  .search-bar {\n    width: 100%;\n    margin-bottom: 20px;\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n  }\n  .roles {\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"role-list": `RoleList_role-list__sZ3lw`,
	"search-bar": `RoleList_search-bar__1T-my`
};
export default ___CSS_LOADER_EXPORT___;
